module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "break"
  }), _vm._v(" "), _c('h3', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('p', {
    staticClass: "mediumspace"
  }), _c('p', {
    staticClass: "intro"
  }, [_vm._v("THIS little book is a correlation of the Seven Beatitudes and the Seven Last Words. The eighth beatitude, in the language of Saint Thomas Aquinas, “is a confirmation and a declaration of all those that precede. Because from the very fact that a man is confirmed in poverty of spirit, meekness, and the rest, it follows that no persecution will induce him to renounce them. Hence the eighth beatitude corresponds in a way to all the preceding seven.” ")]), _vm._v(" "), _c('p', {
    staticClass: "intro",
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("There is no strict correspondence between the Seven Beatitudes and the Seven Words, but this work assumes they are not unrelated, for one seems to be related to the other as precept and deed. Both were delivered on a mountain; Our Lord began his public life on the Mount of the Beatitudes and closed it on the Mount of Calvary. The story of how he practiced the meekness, the mercy, and the poverty of the Beatitudes is here told. If it brings just one soul closer to Our Lord and his Blessed Mother it will have been eminently worthwhile. ")]), _vm._v(" "), _c('p', {
    staticClass: "intro",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("Fulton J. Sheen ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4898e1c1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_introduction.vue
// module id = 72
// module chunks = 0